module.exports = __webpack_public_path__ + "img/yya.51a9a294.jpg";